export default __webpack_public_path__ + "static/media/telegram-icon.dc19ea9a.svg";